import { Mail } from 'lucide-react'
import { useState } from 'react'
import { useEvents, useOutbox, useOutboxItem } from '../../api/hooks'
import { Badge, Card, EmptyState, PageHeader, Select, Spinner } from '../../components/ui'
import { fmtDateTime } from '../../lib/format'

const KIND_LABEL: Record<string, string> = { INBJUDAN: 'Inbjudan', TEST: 'Test', BEKRAFTELSE: 'Bekräftelse', PAMINNELSE: 'Påminnelse', SYSTEM: 'System' }
const KIND_TONE: Record<string, 'navy' | 'neutral' | 'success' | 'warning'> = { INBJUDAN: 'navy', TEST: 'neutral', BEKRAFTELSE: 'success', PAMINNELSE: 'warning' }

export function OutboxPage() {
  const [eventId, setEventId] = useState('')
  const events = useEvents(true)
  const outbox = useOutbox(eventId || undefined)
  const [selected, setSelected] = useState<string | null>(null)
  const item = useOutboxItem(selected)

  return (
    <>
      <PageHeader title="Skickade mejl" subtitle="Allt systemet har skickat: inbjudningar, bekräftelser och testmail. I piloten levereras inget – mejlen landar här." actions={
        <Select value={eventId} onChange={(e) => setEventId(e.target.value)} className="w-72">
          <option value="">Alla event</option>
          {events.data?.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </Select>
      } />
      <div className="grid gap-4 lg:grid-cols-[420px_minmax(0,1fr)]">
        <Card padded={false} title="Senaste" actions={<span className="text-xs text-ink-500">{outbox.data?.length ?? 0} visas</span>}>
          {outbox.isLoading ? <Spinner /> : outbox.data?.length === 0 ? <div className="p-4"><EmptyState icon={<Mail className="size-6" />} title="Inga mejl" /></div> : (
            <ul className="max-h-[70vh] divide-y divide-line-100 overflow-auto">
              {outbox.data?.map((m) => (
                <li key={m.id}>
                  <button onClick={() => setSelected(m.id)} className={`w-full px-4 py-3 text-left hover:bg-navy-50/60 ${selected === m.id ? 'bg-navy-50' : ''}`}>
                    <div className="flex items-center justify-between gap-2"><Badge tone={KIND_TONE[m.kind] ?? 'neutral'}>{KIND_LABEL[m.kind] ?? m.kind}</Badge><span className="text-xs tabular-nums text-ink-400">{fmtDateTime(m.created_at)}</span></div>
                    <div className="mt-1.5 truncate text-sm font-medium text-ink-900">{m.subject}</div>
                    <div className="truncate text-xs text-ink-500">Till {m.to_name ? `${m.to_name} <${m.to_email}>` : m.to_email}</div>
                  </button>
                </li>
              ))}
            </ul>
          )}
        </Card>
        <Card padded={false} title={item.data ? item.data.subject : 'Välj ett mejl'}>
          {item.data ? (
            <>
              <div className="border-b border-line-100 px-4 py-2.5 text-xs text-ink-500">Från {item.data.from_name} &lt;{item.data.from_email}&gt; · Till {item.data.to_email} · via {item.data.provider}</div>
              <iframe title="Mejl" srcDoc={item.data.html} sandbox="" className="h-[68vh] w-full bg-page" />
            </>
          ) : <p className="p-6 text-sm text-ink-500">Klicka på ett mejl i listan för att se exakt vad mottagaren fick.</p>}
        </Card>
      </div>
    </>
  )
}
